import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { env } from "@/config/environment";
import { LoginPage } from "@/components/LoginPage";
import { Layout } from "@/components/Layout";
import { DashboardPage } from "@/pages/DashboardPage";
import { ActivityPage } from "@/pages/ActivityPage";
import { UsersPage } from "@/pages/UsersPage";
import { UserDetailPage } from "@/pages/UserDetailPage";
import { CreditsPage } from "@/pages/CreditsPage";
import { AnalyticsPage } from "@/pages/AnalyticsPage";
import { FunnelPage } from "@/pages/FunnelPage";
import { DeployHistory } from "@/pages/DeployHistory";
import { DevReplication } from "@/pages/DevReplication";
import { DevRefresh } from "@/pages/DevRefresh";

export function App() {
  const { authed, login, logout, error } = useAuth();

  // Still checking stored session
  if (authed === null) {
    return (
      <>
        <div className="theatre" />
        <div className="screen" style={{ alignItems: "center", justifyContent: "center" }}>
          <div className="loading">Warming up the projector...</div>
          <div className="screen-corners-bottom" />
        </div>
      </>
    );
  }

  if (!authed) {
    return <LoginPage onLogin={login} error={error} />;
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout onLogout={logout} />}>
          <Route index element={<DashboardPage />} />
          <Route path="activity" element={<ActivityPage />} />
          <Route path="users" element={<UsersPage />} />
          <Route path="users/:userId" element={<UserDetailPage />} />
          <Route path="credits" element={<CreditsPage />} />
          <Route path="analytics" element={<AnalyticsPage />} />
          <Route path="funnel" element={<FunnelPage />} />
          {/* Prod-only routes. On Dev, these tools have no data and the
              prod-to-dev-refresh function doesn't live here — redirect home. */}
          <Route
            path="deploy-history"
            element={env.isDev ? <Navigate to="/" replace /> : <DeployHistory />}
          />
          <Route
            path="dev-replication"
            element={env.isDev ? <Navigate to="/" replace /> : <DevReplication />}
          />
          <Route
            path="dev-refresh"
            element={env.isDev ? <Navigate to="/" replace /> : <DevRefresh />}
          />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
